import React, { useCallback, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlayIcon, XIcon } from 'lucide-react';
import { site } from '../data/site';
const embedParams = new URLSearchParams({
  autoplay: '1',
  rel: '0',
  modestbranding: '1',
  playsinline: '1',
  iv_load_policy: '3',
  color: 'white'
}).toString();
export function VideoCard() {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, close]);
  return <figure className="w-full" data-id="element-116" data-mp="2c1unglar89io">
      <div className="relative overflow-hidden rounded-2xl border border-cream/15 bg-forest-deep shadow-2xl shadow-black/40" data-id="element-117" data-mp="2o3q8drdoc8e">
        <div className="relative aspect-video w-full" data-id="element-118" data-mp="3ttvbozu7n0ov">
          <button type="button" onClick={() => setOpen(true)} className="group absolute inset-0 h-full w-full focus:outline-none focus-visible:ring-2 focus-visible:ring-cream focus-visible:ring-offset-2 focus-visible:ring-offset-forest" aria-label={`${site.video.label} — ${site.video.caption}`} data-id="element-119" data-mp="3twhlz78hjuas">
            <img src={site.video.posterUrl} alt="Count Club event video thumbnail" className="h-full w-full object-cover transition duration-700 group-hover:scale-[1.03]" data-id="element-120" data-mp="ggjnexxllg1e" />
            <span className="absolute inset-0 bg-forest-deep/45 transition group-hover:bg-forest-deep/30" data-id="element-121" data-mp="7my7vcdlzuqx" />
            <span className="absolute inset-0 flex flex-col items-center justify-center gap-4" data-id="element-122" data-mp="14777siop9y4u">
              <motion.span whileHover={{
              scale: 1.08
            }} transition={{
              type: 'spring',
              stiffness: 320,
              damping: 20
            }} className="flex h-16 w-16 items-center justify-center rounded-full bg-cream text-forest shadow-lg" data-id="element-123" data-mp="zd2wjn8ej3xy">
                <PlayIcon size={24} className="ml-1" fill="currentColor" data-id="element-124" data-mp="2jvvo1atu2ynx" />
              </motion.span>
              <span className="text-xs uppercase tracking-widest2 text-cream" data-id="element-125" data-mp="2otx7hwv68zzx">
                {site.video.label}
              </span>
            </span>
          </button>
        </div>
      </div>
      <figcaption className="mt-3 text-center text-xs uppercase tracking-widest2 text-cream-muted" data-id="element-126" data-mp="2fweh0cyrdtgn">
        {site.video.caption}
      </figcaption>

      <AnimatePresence data-id="element-127" data-mp="25wdtsfxrqt76">
        {open && <motion.div role="dialog" aria-modal="true" aria-label="Count Club event video" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={close} className="fixed inset-0 z-[100] flex items-center justify-center bg-forest-deep/95 p-4 backdrop-blur-sm sm:p-8" data-id="element-128" data-mp="25xf6spychprj">
            <button type="button" onClick={close} aria-label="Close video" className="absolute right-4 top-4 rounded-full border border-cream/25 p-2.5 text-cream transition hover:bg-cream hover:text-forest sm:right-6 sm:top-6" data-id="element-129" data-mp="1yd4jmkhfuqh2">
              <XIcon size={20} data-id="element-130" data-mp="23c7qmagzb6ro" />
            </button>

            <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.97
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} onClick={event => event.stopPropagation()} className="aspect-video w-full max-w-5xl overflow-hidden rounded-xl bg-black shadow-2xl" data-id="element-131" data-mp="23bfv0zndt91e">
              <iframe className="h-full w-full" src={`https://www.youtube-nocookie.com/embed/${site.video.youtubeId}?${embedParams}`} title="Count Club event video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowFullScreen data-id="element-132" data-mp="i0phr94491wf" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </figure>;
}